<div class="amount-card">
  <div *ngIf="setAmount(raised)" class="amount">
    <div *ngIf="(vars.pageName === 'stories' || isMobile) && fundraiser?.raised?.backers && fundraiser?.raised?.beforeTickrBackers>10 && !isFundraiserEnded; else lessBackers">
      <div *ngIf="showRaisedAmt">
        <app-currency-icon *ngIf="currency" [currency]="currency"></app-currency-icon>
        <!--Counto directive to animate number -->
        <span counto
          step="30"
          [countTo]="raised"
          [countFrom]="fundraiser.raised.beforeTickr ? fundraiser.raised.beforeTickr : raised"
          (countoChange)="counto = $event" duration="1">
          {{ counto  | inrFormat:currency}} <span *ngIf="raised && vars.showKCart" class="raised-for-extra-products">raised</span>
        </span>
      </div>
      <app-placeholder-loader *ngIf="!showRaisedAmt" type="text" [count]="1"></app-placeholder-loader>
    </div>
    <ng-template #lessBackers>
      <div>
        <app-currency-icon *ngIf="currency" [currency]="currency"></app-currency-icon>
        {{(raised?raised:'0') | inrFormat:currency}} <span *ngIf="raised && vars.showKCart" class="raised-for-extra-products">raised</span>
      </div>
    </ng-template>
  </div>
  <span *ngIf="currency && (goal || raised) && !fundraiser?.is_multi_patient_campaign && !vars.showKCart" class="raised">
    <span *ngIf="raised">{{isFundraiserEnded || !goal ? 'raised':'raised of'}}</span>&nbsp;
    <span *ngIf="!isFundraiserEnded && goal && goal!==0">
      <span *ngIf="currency" class="numbers">
        <app-currency-icon [currency]="currency"></app-currency-icon>
        {{goal | inrFormat:currency}}
      </span> goal
    </span>
  </span>

  <div class="progressbar">
    <app-progress-bar *ngIf="!vars.showKCart && !isFundraiserEnded && setAmount(raised) && goal && goal!==0 && !fundraiser?.is_multi_patient_campaign" [amount]="raised" [goal]="goal" height="12px"></app-progress-bar>
  </div>
  <div class="amount-footer">
    <span *ngIf="!fundraiser?.settings?.nodonorlist && supporters" class="raised supporters"> <span class="numbers">{{supporters?supporters:0}}</span> supporters</span>
    <span *ngIf="!isFundraiserEnded && date && !fundraiser?.settings?.hidedaysleft" class="raised supporters">
      <span class="numbers">{{date | dayjs:'diffInDays':1}}</span> {{(date | dayjs:'diffInDays':1) > 1 ? 'Days left' : 'Day left'}}
    </span>
  </div>
</div>
